module.exports = __webpack_public_path__ + "assets/img/youtube_b.4927fa95.svg";